import { STOCK_TAKING_CAR_MANAGEMENT_UPDATE_FAST_STOCK_LOADING_DATA } from './constants'

export function updateFastStockLoadingData( args={}, savedForm = false ) {
  return dispatch => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_UPDATE_FAST_STOCK_LOADING_DATA,
      data: {args, savedForm}
    })
  }
}

export function reducer(state, action) {
  if (action.type === STOCK_TAKING_CAR_MANAGEMENT_UPDATE_FAST_STOCK_LOADING_DATA) { 
    return {
      ...state,
      takingCarManagement : {
        ...state.takingCarManagement,
        isFastStockLoading:true,
        fastStockLoading: {
          ...state.takingCarManagement.fastStockLoading,
          saveData: {
            ...state.takingCarManagement.fastStockLoading?.saveData,
            ...action.data.args,
            venta_directa: false,
            venta_convencional: true
          },
          savedForm: action.data.savedForm
        }
      }
    }
  }
  else{
    return state
  }
}